import { useEffect, useState } from 'react'
import { doc, getDoc } from 'firebase/firestore'
import { db } from 'config/firebase'
import {
  TURNSTILE_FEATURE_FLAG_ID,
  isFeatureFlagOnInLocalDev,
  isTurnstileForcedOff,
} from 'constants/featureFlags'

export const useFeatureFlag = (flagId: string): boolean => {
  const forcedOff = flagId === TURNSTILE_FEATURE_FLAG_ID && isTurnstileForcedOff()
  const forcedOn = !forcedOff && isFeatureFlagOnInLocalDev(flagId)
  const [enabled, setEnabled] = useState(forcedOn)

  useEffect(() => {
    if (forcedOff || forcedOn) return
    let cancelled = false
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'featureFlags', flagId))
        if (!cancelled) {
          setEnabled(snap.data()?.enabled === true)
        }
      } catch {
        if (!cancelled) {
          setEnabled(false)
        }
      }
    }
    void load()
    return () => {
      cancelled = true
    }
  }, [flagId, forcedOn, forcedOff])

  if (forcedOff) return false
  return forcedOn || enabled
}
